/**
 * A user's second-factor method. Numeric keys are the persisted contract shared with the
 * backend `MfaMethod` enum and the identity-provider login flow — do not renumber.
 */
export enum MfaMethod {
    EMAIL = 1,
    APP = 2,
    PASSKEY = 3
}
